import { Outlet } from 'react-router-dom';
import { Sidebar } from '../../widgets/sidebar';
import { Header } from '../../widgets/header';

export function DashboardLayout() {
  return (
    <div className="flex min-h-screen bg-gray-50 text-gray-800">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        <Header />

        {/* Page Content */}
        <main className="p-6 flex-1 bg-gray-50">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
